module.exports = __webpack_public_path__ + "static/media/aa13.bc24204a.jpg";